import { render } from "./AppBar.vue?vue&type=template&id=b8e8fcd2&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"

import "./AppBar.vue?vue&type=style&index=0&id=b8e8fcd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e8fcd2"]])

export default __exports__